import { Component } from '@angular/core';
import { MatAnchor } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'qa-find-out-course',
  templateUrl: './find-out-course.component.html',
  styleUrls: ['./find-out-course.component.scss'],
  imports: [MatAnchor, MatIcon, TranslateModule],
})
export class FindOutCourseComponent {
  constructor() {}
}
